module.exports = __webpack_public_path__ + "img/h.9737f1d4.png";